//跨域代理前缀
var API_PROXY_PREFIX = '/manager-api';
var BASE_URL = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_BASE_URL : API_PROXY_PREFIX;
// const BASE_URL = process.env.VUE_APP_API_BASE_URL
module.exports = {
  LOGIN: "".concat(BASE_URL, "/user/login"),
  ROUTES: "".concat(BASE_URL, "/routes")
};